<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex class="text-center" md12>
        <h1 class="header">
          Benvenuto in
          <img
            v-if="config.host == 'egyn'"
            class="header-logo"
            src="../assets/egyn-white.svg"
          />
          <img
            v-if="config.host == 'ebiology'"
            class="header-logo"
            src="../assets/ebiology-white.svg"
          />
        </h1>
        <h2 class="sub-header">Stai modificando un sito esistente</h2>
        <Wizard />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Wizard from "../components/WizardEditor";
import config from "../config/index.js";

export default {
  activated() {},

  mounted() {
    this.$nextTick(function() {
      if (!this.$store.state.editing) this.$router.push("/");
    });
  },

  data() {
    return {
      config: config
    };
  },

  components: {
    Wizard,
  },
};
</script>

<style scoped>
.header {
  background-color: #213b52;
  color: white;
  font-weight: 400;
}
.sub-header {
  color: #999999;
  background-color: #74a2bc;
  color: white;
}

.header-logo {
  height: 40px;
}
</style>
